import { render, staticRenderFns } from "./IconIdCard.vue?vue&type=template&id=e0d0e5e2&"
import script from "./IconIdCard.vue?vue&type=script&lang=js&"
export * from "./IconIdCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports